import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { api } from "@/lib/api";
import { Plus } from "lucide-react";
import { useState } from "react";
import EspecialidadeEdit from "./especialidades-edit";
import EspecialidadeList from "./especialidades-list";
import { Especialidade } from "./interface/Especialidade.interface";

const EspecialidadesPage = () => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [editingEspecialidade, setEditingEspecialidade] = useState<Especialidade | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (especialidade: Especialidade) => {
    setEditingEspecialidade(especialidade);
    setOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (confirm("Deseja realmente excluir esta especialidade?")) {
      try {
        await api.delete(`/api/especialidades/${id}`);
        toast({
          title: "Sucesso",
          description: "Especialidade excluída com sucesso!",
        });
        // Recarrega a lista de especialidades
        setRefreshTrigger(prev => prev + 1);
      } catch (error: any) {
        console.error("Erro ao excluir especialidade:", error);
        toast({
          title: "Erro",
          description: error.response?.data?.message || "Erro ao excluir especialidade",
          variant: "destructive",
        });
      }
    }
  };

  const handleSuccess = () => {
    // Recarrega a lista de especialidades
    setRefreshTrigger(prev => prev + 1);
    setOpen(false);
    setEditingEspecialidade(null);
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-foreground">Especialidades</h2>
            <p className="text-muted-foreground mt-1">Gerencie as especialidades médicas disponíveis</p>
          </div>
          <Button
            className="gap-2"
            onClick={() => {
              setEditingEspecialidade(null);
              setOpen(true);
            }}
          >
            <Plus className="h-4 w-4" />
            Nova Especialidade
          </Button>
        </div>

        <EspecialidadeList
          onEdit={handleEdit}
          onDelete={handleDelete}
          refreshTrigger={refreshTrigger}
        />

        <EspecialidadeEdit
          open={open}
          onOpenChange={setOpen}
          especialidade={editingEspecialidade}
          onSuccess={handleSuccess}
        />
      </div>
    </Layout>
  );
};

export default EspecialidadesPage;
